import { useState, useEffect } from 'react';
import { AlertTriangle, X } from 'lucide-react';
import { API_URL, publicAnonKey } from '../utils/supabaseClient';

export function BackendStatusBanner() {
  const [isBackendDown, setIsBackendDown] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);

  useEffect(() => {
    checkBackendHealth();
  }, []);

  async function checkBackendHealth() {
    try {
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 5000); // 5 second timeout

      const response = await fetch(`${API_URL}/health`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${publicAnonKey}`,
        },
        signal: controller.signal,
      });

      clearTimeout(timeoutId);

      if (!response.ok) {
        setIsBackendDown(true);
      }
    } catch (error) {
      // Silent fail - backend might be starting up or CORS issue in preview
      // Only log in dev mode
      if (import.meta.env.DEV) {
        console.log('[BACKEND STATUS] Health check failed (this is normal in preview):', error);
      }
      // Don't set backend down for fetch errors in preview mode
      // Only set it down if we get a clear server error response
    }
  }

  if (!isBackendDown || isDismissed) {
    return null;
  }

  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-amber-500 text-white px-4 py-3 shadow-lg">
      <div className="max-w-7xl mx-auto flex items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <AlertTriangle className="w-5 h-5 flex-shrink-0" />
          <div className="text-sm font-medium">
            <strong>Backend Server Unavailable:</strong> Authentication and analysis features are currently not working. 
            The Supabase Edge Function may not be deployed yet.
          </div>
        </div>
        <button
          onClick={() => setIsDismissed(true)}
          className="p-1 hover:bg-amber-600 rounded transition-colors"
          aria-label="Dismiss"
        >
          <X className="w-5 h-5" />
        </button>
      </div>
    </div>
  );
}